import { render, staticRenderFns } from "./Bullhorn.vue?vue&type=template&id=08ba8259"
import script from "./Bullhorn.vue?vue&type=script&lang=js"
export * from "./Bullhorn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports